<template>
  <div id="my-collection">
    <v-container fluid class="content-wrapper px-4 px-md-4">
      <v-tabs v-model="tab" show-arrows active-class="primary200--text">
        <v-tabs-slider color="primary200"></v-tabs-slider>
        <v-tab>{{ 'Active Orders (' + resourcesLength + ')' }}</v-tab>
        <v-tab>{{ 'Orders History (' + ordersLength + ')' }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="pa-4">
        <v-tab-item :transition="false" :reverse-transition="false" eager :key="1">
          <marketplace-services-component
            :my-collection="true"
            @resourcesLength="length => (resourcesLength = length)"
          ></marketplace-services-component>
        </v-tab-item>
        <v-tab-item :transition="false" :reverse-transition="false" eager :key="2">
          <v-card class="pa-3 pa-sm-6 pa-lg-6 pa-xl-6 pa-md-6">
            <v-data-table :headers="headersOrder" :items="orders">
              <template v-slot:item.orderDate="{ item }">
                <span>
                  {{ formatDateLocaleAE(item.createdTimestamp) }}
                </span>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip :color="getOrderColor(item.status.id)">
                  {{
                    item.status.description +
                      (item.statusExplicit ? ' - ' + item.statusExplicit : '')
                  }}
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn color="primary" text @click="onViewItem(item)">
                  View
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  v-if="item.uuidResearcher && item.status.id == 'ACCEPTED_BY_PROVIDER'"
                  :to="{ name: 'OrderAcceptedByResearcher', query: { uuid: item.uuidResearcher } }"
                >
                  Accept
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  v-if="item.uuidResearcher && item.status.id == 'ACCEPTED_BY_PROVIDER'"
                  :to="{ name: 'OrderRejectedByResearcher', query: { uuid: item.uuidResearcher } }"
                >
                  Reject
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
          <v-dialog v-model="dialogView" width="500">
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                Order
              </v-card-title>

              <v-card-text class="mt-4">
                <h3>Service:</h3>
                <div>
                  {{ viewItem.resource.name }}
                </div>
                <h3 class="mt-2">Provider:</h3>
                <div>
                  {{ viewItem.resource.provider.name }}
                </div>
                <h3 class="mt-2">Order By:</h3>
                <div>
                  {{ viewItem.user.fullName }}
                </div>
                <h3 class="mt-2">Order Date:</h3>
                <div>
                  {{ formatDateLocaleAE(viewItem.createdTimestamp) }}
                </div>
                <h3 class="mt-2">Status:</h3>
                <div>
                  {{ viewItem.status.description }}
                </div>
                <h3 v-if="viewItem.fromDate" class="mt-2">From:</h3>
                <div>
                  {{ formatDate(viewItem.fromDate) }}
                </div>
                <h3 v-if="viewItem.toDate" class="mt-2">To:</h3>
                <div>
                  {{ formatDate(viewItem.toDate) }}
                </div>
                <h3 v-if="viewItem.useCase" class="mt-2">Use Case:</h3>
                <div>
                  {{ viewItem.useCase }}
                </div>
                <h3 v-if="viewItem.additionalInformation" class="mt-2">
                  Additional Prerequisites:
                </h3>
                <div>
                  {{ viewItem.additionalInformation }}
                </div>
                <h3 v-if="viewItem.publicContactEmail" class="mt-2">Public Contact Email:</h3>
                <div>
                  {{ viewItem.publicContactEmail }}
                </div>
                <h3 v-if="viewItem.cost" class="mt-2">Cost:</h3>
                <div>
                  {{ viewItem.cost }}
                </div>
                <h3 v-if="viewItem.instructions" class="mt-2">Instructions:</h3>
                <div>
                  {{ viewItem.instructions }}
                </div>
                <h3 v-if="viewItem.phone" class="mt-2">Phone:</h3>
                <div>
                  {{ viewItem.phone }}
                </div>
                <h3 v-if="viewItem.email" class="mt-2">Email:</h3>
                <div>
                  {{ viewItem.email }}
                </div>
                <h3 v-if="viewItem.comments" class="mt-2">Comments:</h3>
                <div>
                  {{ viewItem.comments }}
                </div>
                <h3 v-if="viewItem.rejectComments" class="mt-2">Reject Comments:</h3>
                <div>
                  {{ viewItem.rejectComments }}
                </div>
                <div v-if="viewItem.orderEvaluation != null">
                  <h3 class="mt-2">Rating:</h3>
                  <div>
                    {{ viewItem.orderEvaluation.stars + '/5' }}
                  </div>
                  <h3 class="mt-2">Feedback:</h3>
                  <div>
                    {{ viewItem.orderEvaluation.feedback }}
                  </div>
                </div>
              </v-card-text>
              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialogView = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import MarketplaceServicesComponent from '@/components/marketplace/MarketplaceResourcesComponent';
import util from '@/mixins/util';

export default {
  name: 'ResearcherMyCollection',
  mixins: [util],
  components: { MarketplaceServicesComponent },
  data() {
    return {
      tab: null,
      resourcesLength: '-',
      orders: [],
      ordersLength: '-',
      dialogView: false,
      viewItem: {
        resource: {
          provider: {
            name: null,
          },
        },
        user: {
          fullName: null,
        },
        createdTimestamp: null,
        status: {
          description: null,
        },
        useCase: null,
        additionalInformation: null,
        fromDate: null,
        toDate: null,
        publicContactEmail: null,
        cost: null,
        instructions: null,
        phone: null,
        email: null,
        comments: null,
        rejectComments: null,
      },
    };
  },
  mounted() {
    this.axios
      .get('/api/v1/orders')
      .then(res => {
        this.orders = res.data.content;
        this.ordersLength = res.data.total;
      })
      .catch(error => {
        console.log({ error });
      });
  },
  methods: {
    onViewItem(value) {
      console.log('Click View ' + value.id);
      this.dialogView = true;
      this.viewItem = value;
    },
  },
  computed: {
    headersOrder() {
      let headers = [
        /*{ text: 'ID', value: 'id', sortable: true },*/
        { text: 'Service', value: 'resource.name', sortable: true },
        { text: 'Provider', value: 'resource.provider.name', sortable: false },
        { text: 'Order Date', value: 'orderDate', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ];
      return headers;
    },
  },
};
</script>
